module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/ja-奖杯组图.b03a84a4.png";